export default "__VITE_ASSET__d6952500__"